module.exports = __webpack_public_path__ + "static/img/rpacj6.2b25e18a.png";